export * from "./types/RPCEnum"
export * from "./types/RPCRequest"
export * from "./types/RPCResponse"

import type { RPCRequest } from "./types/RPCRequest"
import { EncodeJWT } from "@pdfking/tfunc"

export type RemoteServerConfig = {
  db: string
  secret: string
  url: string
}

export const EncodeServerJWT = async (
  rpc: RPCRequest,
  { secret, url }: RemoteServerConfig
) => {
  const target = url || "https://localhost:2100"
  const token = await EncodeJWT(rpc, secret)
  return `${target}/${token}`
}
